import { useEffect } from "react";
import { useRouter } from "next/router";
import { LoggerService } from "@Front/Services/LoggerService/LoggerService";
import { useResolvedUserContext } from "@Front/Hooks/useResolvedUserContext";

export function useLogLayoutContextSource(layout: string): void {
	const router = useRouter();
	const { contextSource, activeSessionContext, isCustomer, isThirdParty, isInvitedNotary } = useResolvedUserContext();

	useEffect(() => {
		LoggerService.info("ℹ️ [LayoutContextSource] Effective context source", {
			layout,
			pathname: router.pathname ?? "",
			contextSource,
			activeSessionContext,
			isCustomer,
			isThirdParty,
			isInvitedNotary,
		});
	}, [layout, router.pathname, contextSource, activeSessionContext, isCustomer, isThirdParty, isInvitedNotary]);
}
